var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbeddedValuesOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6309 7.51222H19.4689V3.82422",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6299 12.9492H19.4679V16.6372",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6309 10.3125H18.2809",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36926 7.26222H0.53125V3.57422",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36926 12.6992H0.53125V16.3872",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M4.36777 10.0625H1.71777",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 15.6113V19.4863",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1309 15.6113V18.1743",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2314 15.6113V19.4863",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.03125 4.38672V0.511719",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1309 4.38722V1.82422",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2314 4.38672V0.511719",
    stroke: "#AECDFC",
    strokeLinecap: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0312 15.5123H6.03104C5.20406 15.5123 4.53125 14.8391 4.53125 14.0116V6.01242C4.53125 5.18492 5.20406 4.51172 6.03104 4.51172H14.0312C14.8586 4.51172 15.5318 5.18492 15.5318 6.01242V14.0116C15.5318 14.8391 14.8586 15.5123 14.0312 15.5123ZM10.0315 7.01181C8.37722 7.01181 7.03133 8.3577 7.03133 10.012C7.03133 11.6664 8.37722 13.0122 10.0315 13.0122C11.6859 13.0122 13.0317 11.6664 13.0317 10.012C13.0317 8.3577 11.6859 7.01181 10.0315 7.01181Z",
    fill: "#272D55"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0312 15.0123C14.5829 15.0123 15.0318 14.5634 15.0318 14.0116V6.01242C15.0318 5.46063 14.5829 5.01172 14.0312 5.01172H6.03104C5.47976 5.01172 5.03125 5.46063 5.03125 6.01242V14.0116C5.03125 14.5634 5.47976 15.0123 6.03104 15.0123H14.0312ZM10.0315 6.51181C11.9616 6.51181 13.5317 8.082 13.5317 10.012C13.5317 11.942 11.9616 13.5122 10.0315 13.5122C8.10152 13.5122 6.53133 11.942 6.53133 10.012C6.53133 8.082 8.10152 6.51181 10.0315 6.51181ZM14.0312 16.0123H6.03104C4.92836 16.0123 4.03125 15.1148 4.03125 14.0116V6.01242C4.03125 4.90924 4.92836 4.01172 6.03104 4.01172H14.0312C15.1343 4.01172 16.0318 4.90924 16.0318 6.01242V14.0116C16.0318 15.1148 15.1343 16.0123 14.0312 16.0123ZM10.0315 7.51181C8.65293 7.51181 7.53133 8.63341 7.53133 10.012C7.53133 11.3906 8.65293 12.5122 10.0315 12.5122C11.4102 12.5122 12.5317 11.3906 12.5317 10.012C12.5317 8.63341 11.4102 7.51181 10.0315 7.51181Z",
    fill: "#272D55"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbeddedValuesOperationIcon);
export default __webpack_public_path__ + "static/media/EmbeddedValuesOperationIcon.c615c991bd317de789d7030a96fdb667.svg";
export { ForwardRef as ReactComponent };